import React from 'react'
import "./bestsellers.css"
import BSProducts from './BSProducts/BSProducts'

function Bestsellers({products}: any) {
  const firstProducts = products?.data?.slice(9, 11);
  const secProducts = products?.data?.slice(12, 14);
  return (
    <section className="bs-container">
      <div className="bs-content">
        <div className="bs-text">
          <h2 className="bs-heading">Get the Bestsellers at your Doorstep</h2>
          <p className="bs-para">Order Now</p>
        </div>
        <div className="bs-row">
          <div className="row1">
            {firstProducts?.map((item: any)  => (
            <BSProducts key={item.id} id={item.id} data={item.attributes} />
            ))}
          </div>
          <div className="row2">
            {secProducts?.map((item: any)  => (
            <BSProducts key={item.id} id={item.id} data={item.attributes} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Bestsellers
